var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightGreenCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187,
    height: 187,
    viewBox: "0 0 187 187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20811",
    "data-name": "Path 20811",
    d: "M93.5,187A93.5,93.5,0,1,0,0,93.5,93.5,93.5,0,0,0,93.5,187Z",
    fill: "rgba(70,173,165,0.15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightGreenCircle);
export default __webpack_public_path__ + "static/media/light-green-circle.d608771cfba65f259829ccee1555881f.svg";
export { ForwardRef as ReactComponent };